import { useSelector } from 'react-redux';
import { IDealSourceData, IDealSourceDataFlags } from 'modules/core/types/dealSource';
import {
  getDealSourceData as getRACDealSourceData,
  getDealSourceDataFlags as getRACDealSourceDataFlags,
  getFirstDealSourceRender as getRACFirstDealSourceRender,
  getRACState,
} from 'store/selectors/RACAffordabilityEngine.selector';
import { getLenderState } from 'store/selectors/lenders.selector';
import { DEAL_SOURCE_DATA_FLAGS_INITIAL } from 'store/utils/dealSourceDataFlags.utils';
import { TableName } from 'modules/core/enums';

export interface IDealSourceContext {
  dealSourceData: IDealSourceData;
  dealSourceDataFlags: IDealSourceDataFlags;
  firstDealSourceRender: boolean;
  tierEditable: boolean;
  isDealSourceDataEmpty: boolean;
}

export function useDealSourceData(context: TableName.RAC | TableName.LENDER): IDealSourceContext {
  const racDealSourceData = useSelector(getRACDealSourceData);
  const racDealSourceDataFlags = useSelector(getRACDealSourceDataFlags);
  const racFirstDealSourceRender = useSelector(getRACFirstDealSourceRender);
  const racState = useSelector(getRACState);
  const lenderState = useSelector(getLenderState);

  if (context === TableName.RAC) {
    return {
      dealSourceData: racDealSourceData,
      dealSourceDataFlags: racDealSourceDataFlags,
      firstDealSourceRender: racFirstDealSourceRender,
      tierEditable: racState.dealSourceTierEditable,
      isDealSourceDataEmpty: Object.keys(racDealSourceData || {}).length === 0,
    };
  }

  return {
    dealSourceData: lenderState?.dealSourceData ?? ({} as IDealSourceData),
    dealSourceDataFlags: lenderState?.dealSourceDataFlags ?? DEAL_SOURCE_DATA_FLAGS_INITIAL,
    firstDealSourceRender: lenderState?.firstDealSourceRender ?? true,
    tierEditable: lenderState?.dealSourceTierEditable ?? false,
    isDealSourceDataEmpty: Object.keys(lenderState?.dealSourceData || {}).length === 0,
  };
}
